import React, { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { USER_FIELDS } from '../../constants/schemaUser';
import { selectUserLocationList, useSubscriptionsUserActions } from '../../store/useSubscriptionsUserStore';
import AdditionalInfo from '../AdditionalInfo/AdditionalInfo';
import EmailNotificationsUser from '../EmailNotificationsUser/EmailNotificationsUser';
import style from './style.module.scss';

const StepNotifications = ({ user, control }) => {
  const { setAllFacilitiesChecked, setDefaultLocs } = useSubscriptionsUserActions();
  const userLocationsList = selectUserLocationList();

  const allFacilities = useWatch({
    control,
    name: USER_FIELDS.ALL_FACILITIES,
  });

  useEffect(() => {
    if (!user?.id && userLocationsList.length > 1) {
      setAllFacilitiesChecked(
        1,
        userLocationsList.map((loc) => loc.id),
      );
    } else {
      setDefaultLocs([userLocationsList?.[0].id]);
    }
    return () => {
      setAllFacilitiesChecked(0);
    };
  }, []);

  return (
    <div className={style.notificationsStep}>
      <AdditionalInfo user={user} control={control} allFacilities={allFacilities} />
      <EmailNotificationsUser locations={userLocationsList} />
    </div>
  );
};

export default StepNotifications;
